import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Smile, Meh, Frown } from "lucide-react";

const MoodCheckIn = () => {
  const [mood, setMood] = useState<"good" | "neutral" | "bad" | null>(null);

  const advice = {
    good: "That's great! Keep up the positive energy. Maybe share a smile with someone today.",
    neutral:
      "Feeling okay is perfectly fine. Take a moment to stretch or drink some water.",
    bad: "It's okay not to be okay. Try a 1-minute breathing exercise or take a short walk.",
  };

  return (
    <Card className="h-full bg-white/40 backdrop-blur-md border-white/20 shadow-sm hover:shadow-md transition-all duration-300">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Smile className="w-5 h-5 text-primary" />
          Mood Check-in
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        {!mood ? (
          <div className="flex flex-col items-center space-y-6">
            <p className="text-muted-foreground">
              How are you feeling right now?
            </p>
            <div className="flex gap-4">
              <Button
                variant="outline"
                onClick={() => setMood("good")}
                className="flex flex-col items-center gap-2 h-auto p-4 hover:bg-accent hover:text-accent-foreground"
              >
                <Smile className="w-8 h-8 text-primary" />
                <span className="text-xs font-medium">Good</span>
              </Button>
              <Button
                variant="outline"
                onClick={() => setMood("neutral")}
                className="flex flex-col items-center gap-2 h-auto p-4 hover:bg-accent hover:text-accent-foreground"
              >
                <Meh className="w-8 h-8 text-primary" />
                <span className="text-xs font-medium">Okay</span>
              </Button>
              <Button
                variant="outline"
                onClick={() => setMood("bad")}
                className="flex flex-col items-center gap-2 h-auto p-4 hover:bg-accent hover:text-accent-foreground"
              >
                <Frown className="w-8 h-8 text-primary" />
                <span className="text-xs font-medium">Rough</span>
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center space-y-4 py-2">
            <p className="text-lg font-medium text-foreground">
              {mood === "good" && "Glad to hear it!"}
              {mood === "neutral" && "Steady as she goes."}
              {mood === "bad" && "Sending you good vibes."}
            </p>
            <p className="text-muted-foreground text-sm">{advice[mood]}</p>
            <Button
              variant="ghost"
              onClick={() => setMood(null)}
              className="w-full mt-2"
            >
              Check in again
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MoodCheckIn;
